// Client/ClientDetail.tsx
import React, {useContext, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {axios} from "Auth/axiosConfig";
import {Accordion, AccordionDetails, AccordionSummary} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useErrorProcessing} from "Core/components/ErrorProvider";
import ConsultationsWrapper from "Consultation/ConsultationsWrapper";
import UserAvatar from "User/UserAvatar";
import CircularProgress from "Core/components/elements/CircularProgress";

import {IUser} from "../../Types/core/user";
import {AuthContext, AuthContextType} from "Auth/AuthContext";
import {useTheme} from "Theme/ThemeContext";
import pprint from '../../Utils/pprint';
import {IConsultation} from "../../Types/psychology/consultation";

interface ClientDetailProps {
    className?: string;
}

const ClientDetail: React.FC<ClientDetailProps> = ({className}) => {
    const {id} = useParams<{ id: string }>();
    const {isAuthenticated} = useContext(AuthContext) as AuthContextType;
    const {byResponse, notAuthentication} = useErrorProcessing();
    const [client, setClient] = useState<IUser | null>(null);
    const [clientNotFound, setClientNotFound] = useState(false);
    const [consultations, setConsultations] = useState<IConsultation[]>([]);
    const [loading, setLoading] = useState(true);
    // const navigate = useNavigate();
    const {plt} = useTheme();

    useEffect(() => {
        if (!isAuthenticated) {
            notAuthentication();
            return;
        }
        axios.get(`/api/v1/psychologist/client/${id}/`)
            .then(response => {
                pprint(`Client ID:${id}`);
                pprint(response.data);
                setClient(response.data);
                if (response.data.length < 1) setClientNotFound(true);
                setLoading(false);
            }).catch(error => byResponse(error))
        axios.get(`/api/v1/psychologist/client/${id}/consultations/`)
            .then(response => {
                pprint(`Client ID:${id} Consultations`);
                pprint(response.data);
                setConsultations(response.data);
                setLoading(false);
            }).catch(error => byResponse(error))
    }, [id, byResponse]);

    if (loading || !client) return <CircularProgress size={'150px'}/>;
    if (clientNotFound) return <div className={'p-3 text-center mt-2'}>Такого клиента не существует.</div>;

    return (
        <div className={`${className} fc gap-2 py-3 overflow-y-auto no-scrollbar`}>
            <div className={'fccc gap-1'}>
                <UserAvatar size={'8rem'} avatar={client.avatar}/>
                <span className={`mt-2 fs-5`}
                      style={{color: plt.text.primary80}}>{client.first_name} {client.last_name}</span>
                <span>Имя пользователя: {client.username}</span>
                {client.email && <span>Почта: {client.email}</span>}
            </div>

            {consultations.length > 0
                ?
                <Accordion className={`bg-transparent m-0`}

                           sx={{backgroundImage: 'none', boxShadow: 'none', color: plt.text.primary80}}>
                    <AccordionSummary
                        className={'m-0 minh-50px'}
                        sx={{'& .Mui-expanded': {margin: '12px 0 !important'}}}
                        expandIcon={<ExpandMoreIcon
                            style={{color: plt.text.primary50}}/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                    <span className={`fs-5`}
                          style={{color: plt.text.primary80}}>
                        Консультации с {client.first_name} {client.last_name}
                    </span>
                    </AccordionSummary>
                    <AccordionDetails className={'pt-0'}>
                        <div className={'fc gap-2'}>
                            <ConsultationsWrapper className={'p-3'} consultations={consultations}/>
                        </div>
                    </AccordionDetails>
                </Accordion>
                :
                <span>Нет консультаций с этим клиентом.</span>
            }
        </div>
    );
};

export default ClientDetail;
